import React from "react";
import BubblesBackground from "../components/site/BubblesBackground";
import PelageHero from "../components/site/PelageHero";
import Manifesto from "../components/site/Manifesto";
import EditorialMarquee from "../components/site/EditorialMarquee";
import BottleReveal from "../components/site/BottleReveal";
import LaunchFooter from "../components/site/LaunchFooter";
import Intro from "../components/site/Intro";

const VICTORY_BOTTLE =
    "https://customer-assets-rejwkqb3.emergentagent.net/job_victory-beverages/artifacts/xl8lyqvk_Screenshot%202026-08-03%20at%2011.04.00%E2%80%AFPM.png";

const ComingSoon = () => {
    return (
        <div
            className="relative w-full overflow-x-hidden"
            data-testid="coming-soon-page"
        >
            <Intro />

            {/* Persistent light-bubble background across ivory sections */}
            <BubblesBackground variant="light" density={26} />

            {/* ---------- HERO (Pelage-inspired) ---------- */}
            <PelageHero />

            {/* ---------- Marquee ---------- */}
            <EditorialMarquee
                theme="light"
                text="Victory Cola · Hot-Fill Juice · More Flavours Coming · Bottled with Purpose ·"
            />

            {/* ---------- Bottle Reveal (scroll-driven) ---------- */}
            <BottleReveal bottleUrl={VICTORY_BOTTLE} />

            {/* ---------- Manifesto ---------- */}
            <Manifesto />

            {/* ---------- Second marquee (contrast) ---------- */}
            <EditorialMarquee
                theme="dark"
                text="Blowing · RFC Filling · Label · Packing ·"
            />

            {/* ---------- Footer / Notify ---------- */}
            <LaunchFooter />
        </div>
    );
};

export default ComingSoon;
